<template>
    <div class="report-content">
        <div class="left-view-video-box" v-if="item.video_url">
            <a class="left-view-video-a" :href="item.video_url" target="_blank">
                <img class="left-view-video-img" :src="item.video_img">
                <div class="left-view-video-player-box">
                    <img class="left-view-video-player" src="@/assets/img/video-player.png">
                </div>
            </a>
        </div>

        <div class="right-info-box">
            <div class="name">
                <img :src="item.avatar || require('@/assets/avatar-img.png')" alt=""/>
                <p>{{item.nickname}}</p>
            </div>
            <p class="reason">{{item.reason}}</p>
            <a v-if="item && item.video_url" :href="item.video_url" target="_blank" class="report-link">
                观看视频>
            </a>
            <a v-if="item && item.report_url" :href="item.report_url" target="_blank" class="report-link">
                查看报告详情>
            </a>
<!--            <router-link class="report-link" v-if="item && !item.report_url && !item.video_url" :to="`/detail/` + itemid" href="#查看详情">-->
<!--                敬请期待~-->
<!--            </router-link>-->
        </div>
    </div>
</template>

<script>
    import "../../node_modules/swiper/dist/css/swiper.css";
    import Swiper from "swiper"

    export default {
        name: 'ReportContent',
        props: ['item', 'itemid'],
        data() {
            return {
            }
        },
        created() {

        },
        computed: {},
        mounted() {

        },
        methods: {
            initSwiper() {
                if (this.swiperObj) return;
                this.swiperObj = new Swiper('.swiper-container-report', {
                    loop: true,
                    // slidesPerView: 1,
                    spaceBetween: 0,
                    slidesPerView: 'auto',
                    speed: 600,
                    pagination: {
                        el: '.swiper-pagination-report',
                    },
                });
            }
        },
    }
</script>

<style lang="scss" scoped>
    .swiper-pagination-report {
        bottom: 0;
    }

    .swiper-slide-report{
        padding-bottom: 20px;
    }

    .report-content {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
    }

    .left-view-video-box {
        margin-right: 10px;
    }

    .left-view-video-btn {
        text-align: center;
        color: #0976f1;
        display: block;
        margin-top: 5px;
        font-size: 10px;
    }

    .left-view-video-a {
        display: block;
        position: relative;
    }

    .left-view-video-img {
        width: 66px;
        height: 66px;
        object-fit: cover;
    }

    .left-view-video-player-box {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .4);
    }

    .left-view-video-player {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 30px;
        height: 30px;
    }

    .right-info-box {
        flex: 1;
        font-size: 12px;
        position: relative;

        .report-link {
            width: 100px;
            color: #0976f1;
            display: inline-blockb;
            margin-top: 5px;
            margin-right: 10px;
            font-size: 10px;

            &:hover {
                color: #0969d2;
                text-decoration: underline;
            }

        }
    }

    .name {
        font-size: 15px;
        color: #000000;
        line-height: 26px;
        display: flex;
        align-items: center;

        & > p {
            width: calc(100% - 31px);
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }

        img {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            margin-right: 5px;
        }
    }

    .reason {
        font-size: 10px;
        line-height: 18px;
        margin-top: 10px;
        overflow: hidden;
        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .right-href {
        display: flex;
        cursor: pointer;
        align-items: center;

        & > p {
            font-size: 10px;
            text-decoration: underline;
            color: #0043d6;
            line-height: 13px;
        }

        & > img {
            margin-left: 5px;
            width: 5px;
        }
    }
</style>
